/** @jsxImportSource @emotion/react */
import { Buttons } from '@zip/business-components';
import { BasicHeader } from 'components';
import { useAuth0 } from 'contexts';
import { Constants } from 'global';
import * as illustrations from 'public/illustrations';
import { FC } from 'react';
import * as styles from './ErrorPage.styles';

const ErrorPage: FC = () => {
  const { loginWithRedirect } = useAuth0();

  const redirectLogin = async (): Promise<void> => {
    await loginWithRedirect({});
  };

  const redirectHomepage = async (): Promise<void> => {
    window.location.href = Constants.zipBusinessPaymentsUrl;
  };

  return (
    <>
      <BasicHeader
        alignLogoDesktop="center"
        isAuthenticated={false}
        bottomBorder={true}
        helpButton="None"
      />
      <div css={styles.main}>
        <div css={styles.container}>
          <img
            src={illustrations.HandWithPhoneApp}
            width={96}
            title="handWithPhoneApp"
            alt="handWithPhoneApp"
          />
          <div className="heading1" css={styles.text}>
            Oh no... Looks like something has gone wrong
          </div>
          <div css={styles.buttonsGroup}>
            <Buttons.Primary
              id="homeButton"
              onClick={redirectHomepage}
              css={styles.homeButton}
            >
              Back to homepage
            </Buttons.Primary>
            <Buttons.Tertiary
              id="loginButton"
              onClick={redirectLogin}
              css={styles.loginButton}
            >
              Go to merchant login
            </Buttons.Tertiary>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
